import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductSalesGroup } from 'src/app/assabil-kernel/models/entities/control-tables/product-sales-group';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'product-sales-group-lov',
  templateUrl: './product-sales-group-lov.component.html',
  styleUrls: ['./product-sales-group-lov.component.scss']
})


export class ProductSalesGroupLovComponent extends GenericLovComponent {

    @Input() code         : string; 
    @Input() name         : string; 

    productSalesGroups: ProductSalesGroup[] = [];

    columns = [
        {  prop: 'productSalesGroupCode', name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]
    

//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<ProductSalesGroupLovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "productSalesGroup";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.productSalesGroups = result;
    })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
closeModal(row : ProductSalesGroup){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
